export default {
  items: [
    {
      name: "Trang chủ",
      url: "/admin/trang-chu",
      icon: "fa-regular fa-house",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin", "SalesUser"],
        page: "admin",
      },
    },
    {
      name: "Đăng ký dòng họ",
      url: "/admin/dang-ky-dong-ho",
      icon: "fa-regular fa-users-medical",
      code: "DangKyDongHo",
      meta: {
        allowAccess: ["SystemAdmin", "CustomerCareUser"],
        page: "admin",
      },
      badge: {
        variant: "danger",
        text: "0",
      },
    },
    {
      name: "Dòng họ",
      url: "/admin/dong-ho/danh-sach-dong-ho",
      icon: "fa-regular fa-users-class",
      meta: {
        allowAccess: ["SystemAdmin", "FamilyAdmin", "FamilyUser"],
        page: "admin",
      },
    },
    // {
    //   name: "Thành viên trong gia phả",
    //   url: "/admin/node-gia-pha/danh-sach-node-gia-pha",
    //   icon: "fa-regular fa-share-alt",
    //   meta: {
    //     allowAccess: ["SystemAdmin", "FamilyAdmin", "FamilyUser"],
    //     page: "admin",
    //   },
    // },

    {
      name: "Lời nhắn",
      url: "/admin/loi-nhan/danh-sach-loi-nhan",
      icon: "fa-regular fa-comment-lines",
      code: "LoiNhan",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin"],
        page: "admin",
      },
      badge: {
        variant: "danger",
        text: "0",
      },
    },

    {
      name: "landing page",
      title: true,
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
    },
    {
      name: "Slide",
      url: "/admin/slide",
      icon: "fa-regular fa-sliders-h-square",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin"],
        page: "admin",
      },
    },
    {
      name: "Cấu hình giới thiệu",
      url: "/admin/cau-hinh",
      icon: "fa-regular fa-tools",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin"],
        page: "admin",
      },
    },
    {
      name: "Đánh giá",
      url: "/admin/danh-gia/danh-sach-danh-gia",
      icon: "fa-regular fa-check-circle",
      code: "DanhGia",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin"],
        page: "admin",
      },
      // badge: {
      //   variant: "danger",
      //   text: "0",
      // },
    },
    {
      name: "Bài viết",
      url: "/admin/bai-viet/danh-sach-bai-viet",
      icon: "fa-regular fa-feather-alt",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin"],
        page: "admin",
      },
    },
    {
      name: "đại lý",
      title: true,
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
    },
    {
      name: "Quản lý cấp",
      url: "/admin/dai-ly/cap-dai-ly",
      icon: "fa-regular fa-ranking-star",
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
    },
    {
      name: "Quản lý đại lý",
      url: "/admin/dai-ly/danh-sach-dai-ly",
      icon: "fa-regular fa-shop",
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
    },
    {
      name: "kinh doanh",
      title: true,
      meta: {
        allowAccess: ["SystemAdmin", "SalesUser"],
        page: "admin",
      },
    },
    {
      name: "Đơn hàng",
      url: "/admin/don-hang/danh-sach-don-hang",
      icon: "fa-regular fa-list-alt",
      meta: {
        allowAccess: ["SystemAdmin", "SalesUser"],
        page: "admin",
      },
      // children: [
      //   {
      //     name: "Đơn hàng",
      //     url: "/admin/don-hang/danh-sach-don-hang",
      //     icon: "fa-regular fa-list-alt",
      //     meta: {
      //       allowAccess: ["SystemAdmin", "SalesUser"],
      //       page: "admin",
      //     },
      //   },
      //   {
      //     name: "Hóa đơn",
      //     url: "/admin/thanh-toan/danh-sach-hoa-don",
      //     icon: "fa-regular fa-cart-plus",
      //     meta: {
      //       allowAccess: ["SystemAdmin", "SalesUser"],
      //       page: "admin",
      //     },
      //   },
      // ],
    },
    {
      name: "Phiếu thanh toán",
      url: "/admin/phieu-thanh-toan/danh-sach-phieu-thanh-toan",
      icon: "fa-sharp fa-regular fa-notes",
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
      children: [
        {
          name: "Tạo phiếu",
          url: "/admin/phieu-thanh-toan/danh-sach-phieu-thanh-toan-viettoc",
          icon: "fa-regular fa-notes-medical",
          meta: {
            allowAccess: ["SystemAdmin"],
            page: "admin",
          },
        },
        {
          name: "Xác nhận phiếu",
          url: "/admin/phieu-thanh-toan/danh-sach-phieu-thanh-toan-dai-ly",
          icon: "fa-regular fa-ballot-check",
          meta: {
            allowAccess: ["SystemAdmin"],
            page: "admin",
          },
        },
      ],
    },
    {
      name: "Thanh toán",
      url: "/admin/thanh-toan/danh-sach-thanh-toan",
      icon: "fa-regular fa-hand-holding-usd",
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
    },

    {
      name: "Bản in",
      url: "/admin/ban-in/danh-sach-ban-in",
      icon: "fa-regular fa-print",
      code: "BanIn",
      meta: {
        allowAccess: [
          "SystemAdmin",
          "SalesManager",
          "InGiaPhaSales",
          "CustomerCareUser",
          "InGiaPhaDesigner",
        ],
        page: "admin",
      },
      badge: {
        variant: "danger",
        text: "0",
      },
    },
    {
      name: "quản lý",
      title: true,
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
    },
    {
      name: "Tài khoản",
      url: "/admin/user",
      icon: "fa-regular fa-user-cog",
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
      children: [
        {
          name: "Dòng họ",
          url: "/admin/user/danh-sach-user",
          icon: "fa-regular fa-users",
          meta: {
            allowAccess: ["SystemAdmin"],
            page: "admin",
          },
        },
        {
          name: "Bán hàng",
          url: "/admin/user/danh-sach-sale",
          icon: "fa-regular fa-user-headset",
          meta: {
            allowAccess: ["SystemAdmin", "SalesUser"],
            page: "admin",
          },
        },
        {
          name: "Quản trị nội dung",
          url: "/admin/user/danh-sach-quan-tri-noi-dung",
          icon: "fa-regular fa-user-edit",
          meta: {
            allowAccess: ["SystemAdmin", "ContentAdmin"],
            page: "admin",
          },
        },
        {
          name: "Thiết kế",
          url: "/admin/user/danh-sach-thiet-ke",
          icon: "fa-regular fa-compass-drafting",
          meta: {
            allowAccess: ["SystemAdmin", "InGiaPhaDesigner"],
            page: "admin",
          },
        },
        {
          name: "Chăm sóc khách hàng",
          url: "/admin/user/danh-sach-cham-soc-khach-hang",
          icon: "fa-regular fa-user-md-chat",
          meta: {
            allowAccess: ["SystemAdmin", "CustomerCareUser"],
            page: "admin",
          },
        },
        {
          name: "Thêm mới tài khoản",
          url: "/admin/user/them-moi-tai-khoan",
          icon: "fa-regular fa-user-plus",
          meta: {
            allowAccess: ["SystemAdmin"],
            page: "admin",
          },
        },
      ],
    },
    {
      name: "Sản phẩm",
      url: "/admin/san-pham/danh-sach-san-pham",
      icon: "fa-sharp fa-regular fa-money-check",
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
    },
    {
      name: "Gói dịch vụ",
      url: "/admin/goi-dich-vu/danh-sach-goi-dich-vu",
      icon: "fa-regular fa-gift",
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
    },
    {
      name: "Thông báo",
      url: "/admin/thong-bao/danh-sach-thong-bao",
      icon: "fa-regular fa-bell",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin"],
        page: "admin",
      },
    },
    {
      name: "Phương thức thanh toán",
      url: "/admin/phuong-thuc-thanh-toan/danh-sach-phuong-thuc-thanh-toan",
      icon: "fa-regular fa-credit-card-blank",
      meta: {
        allowAccess: ["SystemAdmin"],
        page: "admin",
      },
    },
    {
      name: "Template Mail",
      url: "/admin/mail/danh-sach-mail",
      icon: "fa-regular fa-envelope",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin"],
        page: "admin",
      },
    },
    {
      name: "Chính sách",
      url: "/admin/chinh-sach/danh-sach-chinh-sach",
      icon: "fa-regular fa-gavel",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin"],
        page: "admin",
      },
    },
    {
      name: "QR Scan",
      url: "/admin/qr-scan/danh-sach-qr-scan",
      icon: "fa-regular fa-qrcode",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin"],
        page: "admin",
      },
    },
    {
      name: "Câu hỏi thường gặp",
      url: "/admin/cau-hoi/danh-sach-cau-hoi",
      icon: "fa-regular fa-question-circle",
      meta: {
        allowAccess: ["SystemAdmin", "ContentAdmin"],
        page: "admin",
      },
    },
  ],
};
